export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_LANGUAGE_SUCCESS = "SET_LANGUAGE_SUCCESS";
export const SET_LANGUAGE_FAILURE = "SET_LANGUAGE_FAILURE";
